const WPFormsSetup = () => {

	//
	// Enable any "read more links" on GDPR checkboxes
	const checkboxReadMoreClicked = (e) => {
		e.preventDefault();
		e.currentTarget.parentNode.classList.add('js-read-more');
	}
	const initCheckboxReadMoreClicked = () => {
		document.querySelectorAll('.wpforms-field-gdpr-checkbox .read-more').forEach((btn) => {
			btn.removeEventListener('click', checkboxReadMoreClicked);
			btn.addEventListener('click', checkboxReadMoreClicked);
		});
	}
	initCheckboxReadMoreClicked();

	//
	// Enable Confirmation overlay
	const overlay = document.querySelector('#wpforms-confirmation-overlay');
	if(!overlay || !window.wpforms) {
		return;
	}

	// Click outside + close-btn
	overlay.addEventListener('click', (e) => {
		if(!overlay.querySelector('.inner').contains(e.target) || e.target === overlay.querySelector('.close-btn')) {
			document.body.classList.remove('js-wpforms-confirmation-overlay-revealed');
		}
	});

	// Callback that clones the .confirmationEl inside the WPforms container and appends it to the overlay
	const handleSubmitSuccess = (e, response) => {

		// Check if there's a confirmation (We can't use the confirmation markup since it contains the <form> as well...)
		if(!response || !response.data || !response.data.confirmation) {
			return;
		}

		const formId = e.target.dataset.formid;
		if(!formId) {
			return;
		}

		// Get the confirmation DOM element inside the submitted form
		// Use a timeout since this callback may be called before the confirmation is outputted
		// TODO: No need for the extra timeouts - we just wean to be sure
		setTimeout(() => showConfirmationOverlay(formId), 1);
		setTimeout(() => showConfirmationOverlay(formId), 100);
		setTimeout(() => showConfirmationOverlay(formId), 250);
		setTimeout(() => showConfirmationOverlay(formId), 500);
		setTimeout(() => showConfirmationOverlay(formId), 750);
	};

	const showConfirmationOverlay = (formId) => {

		// The WPForm we need to show the confirmation from
		const wpformsContainer = document.querySelector(`#wpforms-${formId}`);
		if(!wpformsContainer) {
			return;
		}

		// If there's a confirmation, then append it to the overlay
		const confirmationEl = wpformsContainer.querySelector('.wpforms-confirmation-container');
		if(confirmationEl) {

			// Clone placeholder and append it to the overlay. Then append the confirmation to the placeholder
			const placeholder = overlay.querySelector('.placeholder');
			while(placeholder.firstChild) {
				placeholder.removeChild(placeholder.firstChild);
			}
			placeholder.append(confirmationEl);

			// The WPForm form is outputted again (via brolokke23_wpforms_frontend_confirmation_message_after)
			// But it might be appended inside its own .wpforms-container (<div id="formId" class="wpforms-container"><div id="formId" class="wpforms-container"> ... </div></div>)
			// We need to clean this up...!
			// (Alternate solution is to AJAX-load the form again (using PHP do_shortcode()), but do_shortcode() is then not available for not-logged-in users!)
			const wpformsContainerNew = wpformsContainer.querySelector('.wpforms-container');
			if(wpformsContainerNew) {
				wpformsContainer.parentNode.replaceChild(wpformsContainerNew, wpformsContainer);
			}

			// Show the overlay
			document.body.classList.add('js-wpforms-confirmation-overlay-revealed');

			// Re-initialize the WPForms
			initialize();
		}
	}

	const initialize = () => {

		// Re-initialize the WPForms (TODO: still required?)
		window.wpforms.init();

		// Setup callback on each WPForms form. TODO: Does it still require jQuery?!
		document.querySelectorAll('.wpforms-form').forEach(wpform => {
			jQuery(wpform).off('wpformsAjaxSubmitSuccess', handleSubmitSuccess); // Remove any callback that may have been set
			jQuery(wpform).on('wpformsAjaxSubmitSuccess', handleSubmitSuccess);
		});

		initCheckboxReadMoreClicked();

		// Re-initialize the WPForms (TODO: still required?)
		window.wpforms.init();
	}

	initialize();
};

export default WPFormsSetup;